import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { css } from "glamor";

class HeaderLink extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    var targetChildren = event.target.children;
    if (targetChildren && targetChildren.length > 0) {
      var firstChild = targetChildren[0];
      window.location.href = firstChild.href;
    }
    this.props.action();
  }

  render() {
    let liCss = css(
      {
        display: "inline-block",
        marginLeft: 0,
        height: "80px",
        lineHeight: "90px",
        padding: "0 16px",
        fontSize: "1.4em",
        fontFamily: "'Titillium Web', sans-serif",
        textTransform: "lowercase",
        ":hover": {
          backgroundColor: "rgba(255, 255, 255, 0.15)",
        },
        "& .active": {
          color: "#ff820a",
        },
      },
      {
        "@media(max-width: 900px)": {
          display: "block",
          width: "100vw",
          height: "54px",
          textAlign: "center",
          lineHeight: "54px",
          padding: 0,
          borderBottom: "1px solid #ccc",
          fontSize: "1.5em",
        },
      }
    );

    let aCss = css(
      {
        textDecoration: "none",
        fontWeight: "normal",
        color: "white",
      },
      {
        "@media(max-width: 900px)": {
          lineHeight: "54px",
        },
      }
    );

    return (
      <li onClick={this.handleClick} className={liCss}>
        <NavLink
          activeClassName="active"
          exact={this.props.exact}
          to={this.props.url}
          className={`${aCss}`}
        >
          {this.props.label}
        </NavLink>
      </li>
    );
  }
}

export default HeaderLink;
